module.exports = __webpack_public_path__ + "img/baicoin.43642f0c.png";